
import React from "react";
import { Elements } from "./Elements";
import { ConfirmDialog } from "./ConfirmDialog";
import PageDesign from "../page_design/PageDesign";
import { i18nManager } from "../../i18n";
import { Button } from "@rivtn/noseur";
import { Schemes } from "../../utils";

interface SnapperProps {
    passId?: string;
    disabled?: boolean;
    style?: React.CSSProperties;
    header: {
        desc: string;
        title: string;
    };
    template?: {
        p: string;
        v: string;
    }[];
    actionReference?: (action: () => void) => void;
}

function Snapper(props: SnapperProps) {

    const { header, passId, template } = props;

    React.useEffect(() => {
        props.actionReference?.(() => onSnap);
    }, []);

    return (<div className="snapper" style={props.style}>
        {Elements.buildSnapper((e) => {
            e.stopPropagation();
            onSnap();
        }, props.disabled)}
    </div>);

    function onSnap() {
        let shallowHeader = { ...header };
        for (const e of (template ?? [])) {
            shallowHeader.desc = shallowHeader.desc.replace(`\${${e.p}}`, e.v);
            shallowHeader.title = shallowHeader.title.replace(`\${${e.p}}`, e.v);
        };
        const dialog = ConfirmDialog({
            noControl: true,
            style: { maxWidth: "90%" },
            contentStyle: { padding: 0 },
            content: (<div className="tournament-pass">
                <PageDesign noControl header={shallowHeader} leftPanelStyle={{ flex: "unset", maxHeight: 600 }} publicId={""} designType={""} onUpdate={updateDesign}
                    secondaryControl={<div className="tour-diag-pass-share">
                        {Elements.buildShareToView()}
                        <span className="link" style={{ marginTop: 50 }} onClick={() => dialog?.hide()}>{i18nManager.Labels.common.close}</span>
                    </div>}
                    secondaryView={<div className="tour-diag-pass-cals">
                        <div />
                        <Button raised scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.download} style={{ margin: "20px 0px 0px 0px", padding: "10px 25px" }} />
                    </div>} />
            </div>),
        });
        dialog.show();
    }

    function updateDesign(pageDesign: any, onDone?: () => void) {

    }

}

export default Snapper;
